import {
    Base
} from './Base';

export const firebaseStorage = new Base();